var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

module.exports = Base.extend({

    formatPhoneAndTime: function (fieldName, separator) {
        var item1 = this.$('input[name="' + fieldName + '0"]').val();
        var item2 = this.$('input[name="' + fieldName + '1"]').val();
        var item3 = this.$('input[name="' + fieldName + '2"]').val();

        if (!item1 && !item2 && !item3) {
            return '';
        } else {
            return item1 + separator + item2 + separator + item3;
        }
    },


    checkRequired: function () {
        var hasError = false;
        var self = this;

        //check form inputs
        this.$('.SubmissionFormElement-inputName--required').each(function (ind, item) {
            if (hasError) return;

            var $wrapper = $(item).closest('.SubmissionFormElement-inputLine');

            if ($wrapper.hasClass('SubmissionFormElement-inputLine--hidden')) return;

            var $input = $('input, textarea', $wrapper).eq(0);
            var inputName = $input.attr('name');
            var inputType = $input.attr('type');

            if (!$input.length) {
                var $input = $('select', $wrapper).eq(0);
                inputType = 'select';
            }

            if (!$input.length) {
                return;
            }

            if (inputType == 'radio') {
                var val = self.$('input[name="' + inputName + '"]:checked').val();

                if (val == undefined) {
                    $wrapper.addClass('SubmissionFormElement-inputLine--error');

                    self.$('input[name="' + inputName + '"]').one('change', function () {
                        $wrapper.removeClass('SubmissionFormElement-inputLine--error');
                    });

                    app.animateWindowScroll($wrapper.offset().top - 80);
                    hasError = true;

                    return;
                }
            } else if (inputType == 'select') {
                var val = $input.val();

                if (val == undefined) {
                    $wrapper.addClass('SubmissionFormElement-inputLine--error');

                    $input.one('input', function () {
                        $wrapper.removeClass('SubmissionFormElement-inputLine--error');
                    });

                    app.animateWindowScroll($wrapper.offset().top - 80);
                    hasError = true;

                    return;
                }
            } else {
                var val = $.trim($input.val());

                /*eslint-disable */
                if ($('input, textarea', $wrapper).length > 1) {
                    val = $('input', $wrapper).eq(0).val() && $('input', $wrapper).eq(1).val() && $('input', $wrapper).eq(2).val();
                }
                /*eslint-enable */

                if (!val) {
                    $input.focus();
                    $wrapper.addClass('SubmissionFormElement-inputLine--error-with-input');

                    $('input', $wrapper).one('input', function () {
                        $wrapper.removeClass('SubmissionFormElement-inputLine--error-with-input');
                    });

                    app.animateWindowScroll($wrapper.offset().top - 80);
                    hasError = true;

                    return;
                }
            }
        });

        return !hasError;
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormBlock.js
// module id = 7
// module chunks = 0